import { getState } from '~src/state';

/**
 * Accesso al formato griglia provino con la configurazione della taglierina
 * Memento di Santini (PE-1406).
 *
 * Attenzione: NON e' un formato generico per la taglierina Memento. E' la
 * messa a punto di un singolo cliente (leve della macchina, formato ricordino
 * e impaginazione), quindi non va riusata per altre organizzazioni che hanno
 * la stessa macchina impostata diversamente: in quel caso serve una voce, un
 * layout e un id dedicati.
 *
 * Di conseguenza la lista qui sotto va tenuta corta: l'objectId di
 * un'organizzazione va aggiunto solo se usa davvero questa configurazione.
 */
export const TAGLIERINA_MEMENTO_SANTINI_ORG_IDS = ['HFuWzzPKjg']; // Santini Onoranze Funebri

export const canUseTaglierinaMementoSantini = () => {
  try {
    const orgId = getState('user.org_pointer.objectId');
    return TAGLIERINA_MEMENTO_SANTINI_ORG_IDS.includes(orgId);
  } catch (err) {
    return false;
  }
};
